import rainforestLogo from "/img/integration/rainforest.png"
import { EmailConfigPage } from "../email-config-page"

export function ConfigRainforestPage() {
  return (
    <EmailConfigPage
      logo={rainforestLogo}
      logoAlt="Rainforest"
      integrationName="rainforest"
      displayName="Rainforest"
      connectPath="/setup/connect/rainforest"
    />
  )
}
